import { Button, Icon, message } from 'antd';
import * as React from 'react';
import I18N from 'src/services/I18NService';
import { EnumCustomControl } from 'src/constants/enum';
import { MallService } from '../../services/MallService';
import { IMallTCMDetail, IMallCPMDetail } from 'src/entity/MallEntity';
import { ISpuMedicineDetail } from 'src/entity/SpuEntity';
import { IPageResult } from 'src/entity/BaseResult';
// import { EnumMedicineCategory } from '../../constants/enum';
import FileService from 'src/services/FileService';
import { IMallPharmacyDetail } from '../../entity/MallEntity';

interface IMallMedicineExportProps {
  /** 名称 */
  title: string;
  /** 药库 */
  pharmacy: IMallPharmacyDetail;
  /** 控件类型 */
  control: EnumCustomControl;
}

interface IMallMedicineExportState {
  loading: boolean;
}

class MallMedicineExportButton extends React.Component<IMallMedicineExportProps, IMallMedicineExportState> {
  constructor(props: IMallMedicineExportProps) {
    super(props);

    this.state = {
      loading: false,
    } as IMallMedicineExportState;
  }

  componentDidMount() { }

  componentWillUnmount() {
    this.setState = () => {
      return;
    };
  }

  /**
   * 导出
   *
   * @memberof MallMedicineExportButton
   */
  doExport = async () => {
    if (this.state.loading) {
      return;
    }
    try {
      this.setState({
        loading: true,
      });
      const { pharmacy } = this.props;
      const fileName = `${pharmacy.name}`;
      let res: Blob | undefined;
      // if (pharmacy.category_code === EnumMedicineCategory.中药) {
      //   const res = await this.getExportMedicineList();
      //   if (!!res) {
      //     FileService.mallTcmExport(fileName, res.mallMedicineList as IMallTCMDetail[], res.spuMedicineList, pharmacy.order_type);
      //   }
      // } else if (pharmacy.category_code === EnumMedicineCategory.中成药) {
      //   const res = await MallService.fetchExportCpmMedicine(pharmacy.uuid);
      //   if (!!res) {
      //     FileService.mallCpmExport(fileName, res);
      //   }
      // }
      res = await MallService.fetchExportGroupMedicine(pharmacy.uuid, pharmacy.category_code);
      if (!!res) {
        FileService.mallGroupMedicineExport(fileName, res);
      }
    } catch (error) {
      if (!!error.response) {
        message.error(JSON.stringify(error.response.data));
      } else {
        message.error(I18N.get('err_export_failure'));
      }
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  /**
   * 获取导出药品数据
   *
   * @memberof MallMedicineExportButton
   */
  getExportMedicineList = async (): Promise<{ mallMedicineList: IMallTCMDetail[] | IMallCPMDetail[]; spuMedicineList: ISpuMedicineDetail[] }> => {
    let mallMedicineList: IMallTCMDetail[] | IMallCPMDetail[] = [];
    let spuMedicineList: ISpuMedicineDetail[] = [];
    try {
      const promiseArray: any[] = [];
      promiseArray.push(
        MallService.searchMedicineDetail({
          medicine_group: this.props.pharmacy.uuid,
          is_deleted: false,
          offset: 0,
          limit: 1000000,
        })
      );
      promiseArray.push(MallService.getSpuMedicineList({ categoryCode: this.props.pharmacy.category_code }));
      const res = await Promise.all(promiseArray);
      if (!!res && res.length === 2) {
        const mallRes: IPageResult<IMallTCMDetail[] | IMallCPMDetail[]> = res[0];
        if (!!mallRes) {
          mallMedicineList = mallRes.results || [];
        }

        const spuRes: IPageResult<ISpuMedicineDetail[]> = res[1];
        if (!!spuRes) {
          // 过滤已删除的SPU
          spuMedicineList = spuRes.results.filter(t => !t.is_deleted) || [];
        }
      }
    } catch (error) {
      console.error(error);
    }

    return {
      mallMedicineList,
      spuMedicineList,
    };
  };

  /**
   * 导出控件
   *
   * @memberof MallMedicineExportButton
   */
  exportElement = (): JSX.Element => {
    const { loading } = this.state;
    const { title, control } = this.props;
    if (control === EnumCustomControl.A) {
      return <a onClick={() => this.doExport()}>{title}</a>;
    } else if (control === EnumCustomControl.BUTTON) {
      return (
        <Button type="default" loading={loading} onClick={this.doExport}>
          <Icon type="download" />
          {title}
        </Button>
      );
    }

    return <span onClick={() => this.doExport()}>{title}</span>;
  };

  render() {
    return this.exportElement();
  }
}

export default MallMedicineExportButton;



// WEBPACK FOOTER //
// ./src/components/common/MallMedicineExportButton.tsx